<template>
    <div>


        <div id="edit-mode" v-if="!editMode">
            <v-btn fab small color="#c42111" @click="turnOnEditMode" v-if="$store.state.user.user_data.is_customer_admin"><v-icon>mdi-wrench</v-icon></v-btn>
        </div>
        <div id="edit-mode" v-if="editMode">
            <v-btn fab small color="#c42111" @click="turnOffEditMode"><v-icon>mdi-check</v-icon></v-btn>
        </div>

        <div id="save-content" v-if="editMode">
            <v-btn fab small color="#c42111" @click="saveHomePageContent"><v-icon>mdi-content-save</v-icon></v-btn>
        </div>

        <v-icon class="loading-content" v-if="loadingContent">fas fa-spinner fa-spin</v-icon>

        <div id="login-editor-container" class="login-editor-container">
            <div id="ckeditor" class="ckeditor" />
        </div>



    </div>
</template>

<script>
//import Editor from '@/ckeditor';
export default {
    name: 'LoginPage',
    props: [],
    components: {
    },
    data: () => ({
        loadingContent: false,
        defaultContent: '',
        loginPageContent: '',
        editMode: false,
        editorObj: null,
        toolbar: null,
        editorConfig: {
            toolbar: {
                items: [
                    'heading',
                    '|',
                    'alignment',
                    '|',
                    'fontFamily',
                    'fontSize',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'link',
                    '|',
                    'bulletedList',
                    'numberedList',
                    'todoList',
                    '|',
                    'indent',
                    'outdent',
                    '|',
                    'imageUpload',
                    'blockQuote',
                    'insertTable',
                    'mediaEmbed',
                    'undo',
                    'redo'
                ]
            },
            language: 'en',
            fontSize: {
                options: [9,11,12,14,16,18,24,32,36,48,72]
            },
            image: {
                toolbar: [
                    'imageTextAlternative',
                    'imageStyle:full',
                    'imageStyle:side'
                ]
            },
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells',
                    'tableCellProperties',
                    'tableProperties'
                ]
            },
            mediaEmbed: {
                previewsInData: true,
                toolbar: [
                    'undo',
                    'fontSize'
                ]
            },
            licenseKey: '',
        }

    }),

    computed: {
    },

    methods: {
        getLoginPageContent: function() {
            let route = (TELSA.apiHost + "settings/wysiwygcontent/login_page_content");
            this.loadingContent = true;
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.loginPageContent = result.wysiwyg_content;
                this.initializeEditor();
                this.loadingContent = false;
            });
        },

        initializeEditor: function() {
            ClassicEditor.create(document.getElementById('ckeditor'), this.editorConfig).then(editor => {
                this.editorObj = editor;
                this.toolbar = document.getElementsByClassName('ck ck-sticky-panel')[0];
                this.turnOffEditMode();
                this.editorObj.setData(this.loginPageContent);

                document.getElementsByClassName('ck ck-content')[0].classList.add('wysiwyg-login');
                document.getElementsByClassName('ck-blurred')[0].classList.add('wysiwyg-login');
            });
        },

        saveHomePageContent: function() {
            this.loginPageContent = this.editorObj.getData();
            let route = (TELSA.apiHost + "settings/wysiwygcontent");
            TELSA.loading(true);
            return this.$http.post(route, {args: {wysiwyg_key: 'login_page_content', wysiwyg_content: this.loginPageContent}}).then(response => {
                let result = response.body;
                console.log(result);
                TELSA.loading(false);
            });
        },



        turnOnEditMode: function() {
            this.editorObj.isReadOnly = false;
            this.toolbar.style.display = 'initial';
            document.getElementsByClassName('ck ck-content')[0].style.border = '#ffffff solid 1px';
            document.getElementsByClassName('ck ck-editor')[0].style.border = '#ffffff solid 1px';
            this.editMode = true;

            document.getElementsByClassName('ck ck-content')[0].classList.add('wysiwyg-login');
            document.getElementsByClassName('ck-blurred')[0].classList.add('wysiwyg-login');
        },

        turnOffEditMode: function() {
            this.editorObj.isReadOnly = true;
            this.toolbar.style.display = 'none';
            document.getElementsByClassName('ck ck-content')[0].style.border = 'none';
            document.getElementsByClassName('ck ck-editor')[0].style.border = 'none';
            this.editMode = false;

            document.getElementsByClassName('ck ck-content')[0].classList.add('wysiwyg-login');
            document.getElementsByClassName('ck-blurred')[0].classList.add('wysiwyg-login');
        },
    },

    mounted() {
        this.getLoginPageContent();
    },

    destroyed() {
        this.editorObj.destroy().then(r => {
            this.editorObj.ui.view.toolbar.element.remove();
            this.editorObj.ui.view.editable.element.remove();
        });
    }
};
</script>

<style scoped>

    .loading-content {
        font-size: 110px;
        margin: 20px calc(50% - (110px / 2));
    }

    #edit-mode {
        position: absolute;
        top: 1em;
        right: 1em;
        z-index: 2;
    }

    #save-content {
        position: absolute;
        top: 1em;
        right: 4em;
        z-index: 2;
    }

</style>


<style>

.wysiwyg-login {
        height: calc(100vh - 450px) !important;
    }


    #login-editor-container {
        height: 100%;
    }
    #ckeditor {
        height: 100%;
    }
    


    .ck-editor[role='application'] .ck.ck-content .login {
        color: #fff;
        background-color: #303030;
        height: calc(700px) !important;
        border: none;
    }

    .ck-blurred .login {
        height: calc(700px) !important;
    }

</style>
